/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import HWLocalStorage from '../../rmsReduxStore/api-service/HWLocalStorage';
import localStorageInstance from '../../rmsReduxStore/api-service/LocalStorageService';


const versionEditAccessAllowedList : string[] = ['84c5b1e7-28a7-4fb1-a869-a3f60ee95318','f1b61727-2cbf-4a95-9760-be993796489b','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7257','e9b21cf0-cc25-4474-a279-04616a0d78f1', 'de227ed8-9e35-4c45-a04d-5af10a6d850f' , 'aefdba75-9d7d-4e9d-aab9-86f2944aad46', '8d59bb3a-ce36-45e4-b530-9198bf6397dd']

const plcLogStopReasonPermittedUserIds: string[] = ['de227ed8-9e35-4c45-a04d-5af10a6d850f', 'f1b61727-2cbf-4a95-9760-be993796489b','aefdba75-9d7d-4e9d-aab9-86f2944aad46' , 'ed7a55fa-b4e5-4728-9f46-5af7295b2758'];


class AccessControl {

    static testToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJFeGljb20iLCJpYXQiOjE3MTA3NDAwODAsIm5iZiI6MTcxMDc0MDA4MCwiZXhwIjoxNzEwNzQzNjgwLCJzdWIiOiI1NjU4YTU0Zi1lYjI3LTQxNmUtOTY0My1lNWJiNDUxZWRjZDkiLCJhdWQiOiJodHRwczovL2V4aWNvbS1zcGluLXJtcy1hcHAtZGV2LWVudi5henVyZXdlYnNpdGVzLm5ldC8iLCJqdGkiOiJmMDcyYWViZi1iZjExLTRkNzYtODZkZS02M2RiODdmZjhmNzkiLCJzZXNzaW9uSWQiOiJhYWRjZjU5Ny0zYTI5LTQwZWItYTFmMS1mMTMyZmY3Nzc3MDEiLCJncmFudFR5cGUiOiJBY2Nlc3MgdG9rZW4iLCJvcmdJZCI6ImQzZDdlNzg0LTI4OTUtNDU5MC05N2M2LTY4ZDMwODA2NmYwNSIsInJvbGVJZCI6ImJkNWQxMTVmLTlkOGEtNDllZS04ZGRkLTI3MTU5Yzc2ZDdkYyIsInNjb3BlIjoiZGFzaGJvYXJkOiogdXNlcjp2aWV3IG1hbmFnZUNoYXJnZXI6dmlldyJ9.2pLI83PYG858aXmHr5eyDNuTYQqiUwWzQVp7-H3EUT4'
    demoUserId = '40a14b2c-2078-41ab-bf47-271dbc27cda0'
    hasChargerVisibilityEditAccess = () => {
        const token = HWLocalStorage.load('accessToken')
        if (!token) return null
        return JSON.parse(atob(token.split('.')[1])).enableVisibilityEdit === 'Enabled'
    }
    isOrgTypeCustomer = () => {
        const token = HWLocalStorage.load('accessToken')
        if (!token) return null
        return JSON.parse(atob(token.split('.')[1])).orgType === 'Customer'
    }

    isOrgTypeExicom = () => {
        const token = HWLocalStorage.load('accessToken')
        if (!token) return null
        return JSON.parse(atob(token.split('.')[1])).orgType === 'Exicom'
    }

    isSuperAdmin = ()=>{
     const role = this.fetchRoleId();
     return role === 'bd5d115f-9d8a-49ee-8ddd-27159c76d7dc'
    }

    static permissions(): string[] | null {
        const token = HWLocalStorage.load('accessToken')
        if (!token) return null
        return JSON.parse(atob(token.split('.')[1])).scope.split(' ');
    }

    static userLevelPermissions(): string[] | null {
        const user: any = HWLocalStorage.load('rms-user');
        if(!user) return null;
        else return user?.accessToModules?.split(',');
    }

    fetchRoleId = () => {
        const token = HWLocalStorage.load('accessToken')
        if (!token) return null
        return JSON.parse(atob(token.split('.')[1])).roleId
    }

    isPermitted = (featureScopes) => {
        return (function () {
            try {
                const permissions = AccessControl.permissions();
                if (!featureScopes) { return false; }
                if (!permissions) { return false; }
                const status = featureScopes.some((scope) => permissions.some((featureScope) => featureScope === '!' + scope))
                if (status) { return false }
                if (permissions && (permissions.indexOf('*.*') !== -1)) { return true; }
                return featureScopes.some((scope) => permissions.some((featureScope) => featureScope === scope));
            } catch { return false; }
        });
    }

    isUserPermitted = (featureScopes) => {
        return (
            function () {
                try {
                    const permissions = AccessControl.userLevelPermissions();
                    if(!featureScopes) { return false; }
                    if(!permissions) { return false; }
                    return featureScopes.some((scope) => permissions.some((featureScope) => featureScope === scope));
                } catch { return false; }
            }
        )
    }
    acAndDcAccess = () => {
        const token = HWLocalStorage.load('accessToken')
        if (!token) return null
        return JSON.parse(atob(token.split('.')[1])).accessToAcAndDc
    }

    // DASHBOARD SCOPES....
    dashboard = {
        view: this.isPermitted(['dashboard:*', 'dashboard:view']),
    }
    // ALARMS SCOPES....
    alarms = {
        view: this.isPermitted(['alarm:*', 'alarm:view']),
        edit: this.isPermitted(['alarm:*', 'alarm:edit']),
        export: this.isPermitted(['alarm:*', 'alarm:export'])
    }

    // MANAGE CHARGERS SCOPES.....
    chargers = {
        view: this.isPermitted(['manageCharger:*', 'manageCharger:view']),
        add: this.isPermitted(['manageCharger:*', 'manageCharger:add']),
        edit: this.isPermitted(['manageCharger:*', 'manageCharger:edit']),
        delete: this.isPermitted(['manageCharger:*', 'manageCharger:delete']),
        export: this.isPermitted(['manageCharger:*', 'manageCharger:export']),
        status: {
            view: this.isPermitted(['manageCharger.status:*', 'manageCharger.status:view'])
        },
        settings: {
            view: this.isPermitted(['manageCharger.setting:*', 'manageCharger.setting:view'])
        },
        systemInfo: {
            view: this.isPermitted(['manageCharger.systemInfo:*', 'manageCharger.systemInfo:view'])
        },
        remoteCommands: {
            view: this.isPermitted(['manageCharger.remoteCommand:*', 'manageCharger.remoteCommand:view'])
        },
        admin: {
            view: this.isPermitted(['manageCharger.admin:*', 'manageCharger.admin:view'])
        }
    }

    //UPDATE SETTINGS OR UPDATE COMMAND SCOPE.....
    updateSetting = {
        view: this.isPermitted(['updateSetting:*', 'updateSetting:view']),
        add: this.isPermitted(['updateSetting:*', 'updateSetting:add']),
        edit: this.isPermitted(['updateSetting:*', 'updateSetting:edit']),
        delete: this.isPermitted(['updateSetting:*', 'updateSetting:delete']),
        export: this.isPermitted(['updateSetting:*', 'updateSetting:export'])
    }

    //SPURIOUS CHARGER SCOPE>.......
    spuriousCharger = {
        view: this.isPermitted(['spuriousCharger:*', 'spuriousCharger:view']),  
    }

    // CHARGING STATIONS SCOPE
    chargingStation = {
        view: this.isPermitted(['chargingStation:*', 'chargingStation:view']),
        add: this.isPermitted(['chargingStation:*', 'chargingStation:add']),
        edit: this.isPermitted(['chargingStation:*', 'chargingStation:edit']),
        delete: this.isPermitted(['chargingStation:*', 'chargingStation:delete']),
        export: this.isPermitted(['chargingStation:*', 'chargingStation:export'])
    }

    // CUSTOMER SCOPES....
    customers = {
        view: this.isPermitted(['customer:*', 'customer:view']),
        add: this.isPermitted(['customer:*', 'customer:add']),
        edit: this.isPermitted(['customer:*', 'customer:edit']),
        delete: this.isPermitted(['customer:*', 'customer:delete']),
        export: this.isPermitted(['customer:*', 'customer:export'])
    }

    // ACCESS CONTROL SCOPES...
    organisation = {
        view: this.isPermitted(['organisation:*', 'organisation:view']),
        add: this.isPermitted(['organisation:*', 'organisation:add']),
        edit: this.isPermitted(['organisation:*', 'organisation:edit']),
        delete: this.isPermitted(['organisation:*', 'organisation:delete']),
        export: this.isPermitted(['organisation:*', 'organisation:export'])
    }

    // Add / Edit / Delete Access is given to super admin for dev + uat only 

    users = {
        view: this.isPermitted(['user:*', 'user:view']),
        add: () => this.isSuperAdmin() || this.isUserPermitted(['userManagement:*'])(),
        edit: () => this.isSuperAdmin() || this.isUserPermitted(['userManagement:*'])(),
        delete: () => this.isSuperAdmin() || this.isUserPermitted(['userManagement:*'])(),
        export: this.isPermitted(['user:*', 'user:export'])
    }

    roles = {
        view: this.isPermitted(['role:*', 'role:view']),
        add: this.isPermitted(['role:*', 'role:add']),
        edit: this.isPermitted(['role:*', 'role:edit']),
        delete: this.isPermitted(['role:*', 'role:delete']),
        export: this.isPermitted(['role:*', 'role:export'])
    }

    // REPORTS SCOPES.....
    reports = {
        chargingHistory: {
            view: this.isPermitted(['report.chargingHistory:*', 'report.chargingHistory:view']),
            export: this.isPermitted(['report.chargingHistory:*', 'report.chargingHistory:export']),
        },
        chargerLog: {
            status: {
                view: this.isPermitted(['report.chargerLog.status:*', 'report.chargerLog.status:view']),
                export: this.isPermitted(['report.chargerLog.status:*', 'report.chargerLog.status:export']),
            },
            setting: {
                view: this.isPermitted(['report.chargerLog.setting:*', 'report.chargerLog.setting:view']),
                export: this.isPermitted(['report.chargerLog.setting:*', 'report.chargerLog.setting:export']),
            },
            systemInfo: {
                view: this.isPermitted(['report.chargerLog.systemInfo:*', 'report.chargerLog.systemInfo:view']),
                export: this.isPermitted(['report.chargerLog.systemInfo:*', 'report.chargerLog.systemInfo:export']),
            }
        },
        exceptionLogs: {
            view: this.isPermitted(['report.exceptionLogs:*', 'report.exceptionLogs:view']),
            export: this.isPermitted(['report.exceptionLogs:*', 'report.exceptionLogs:export'])
        },
        uptimeReports:{
            // view: this.isUserPermitted(['report.uptimeReports:*', 'report.uptimeReports:view']),
            // export: this.isUserPermitted(['report.uptimeReports:*', 'report.uptimeReports:export'])
            view: () => this.isSuperAdmin() || this.isUserPermitted(['report.uptimeReports:*'])() ,
            export: () => this.isSuperAdmin() || this.isUserPermitted(['report.uptimeReports:*'])()
        }
    }

    //CONFIGURE NOTIFICATION SCOPES.....
    configureNotification = {
        add: this.isPermitted(['configureNotification:*', 'configureNotification:add']),
        view: this.isPermitted(['configureNotification:*', 'configureNotification:view']),
        edit: this.isPermitted(['configureNotification:*', 'configureNotification:edit']),
        delete: this.isPermitted(['configureNotification:*', 'configureNotification:delete']),
    }


    //RULE ENGINE SCOPES...
    ruleEngine = {
        view: this.isPermitted(['ruleEngine:*', 'ruleEngine:view']),
        add: this.isPermitted(['ruleEngine:*', 'ruleEngine:add']),
        edit: this.isPermitted(['ruleEngine:*', 'ruleEngine:edit']),
        delete: this.isPermitted(['ruleEngine:*', 'ruleEngine:delete']),
    }

    ruleEngineHistory = {
        view: this.isPermitted(['ruleEngineHistory:*', 'ruleEngineHistory:view']),
    }

    // SOFTWARE VERSION RELEASE SCOPES

    softwareVersionReleases = {
        softwareReleaseDashboard:{
            view: this.isPermitted(['softwareReleases.dashboard:*', 'softwareReleases.dashboard:view'])
        },
        addSoftwareVersion:{
            view: this.isPermitted(['softwareReleases.version:*', 'softwareReleases.version:view']),
            add :  ()=>versionEditAccessAllowedList?.includes(localStorageInstance?.fetchUser()?.id ?? ''),
            edit : ()=>versionEditAccessAllowedList?.includes(localStorageInstance?.fetchUser()?.id ?? ''),
        },

        deployment:{
            internalVersionDeploy: this.isPermitted(['softwareReleases.deployment.internal:*','softwareReleases.deployment.internal:deploy']),
            customerVersionDeploy: this.isPermitted(['softwareReleases.deployment.customer:*','softwareReleases.deployment.customer:deploy'])
        }
    }

    nocDashboard = {
        view: this.isPermitted(['nocDashboard:*', 'nocDashboard:view']),
        add: this.isPermitted(['nocDashboard:*', 'nocDashboard:add']),
        edit: this.isPermitted(['nocDashboard:*', 'nocDashboard:edit']),
        delete: this.isPermitted(['nocDashboard:*', 'nocDashboard:delete']),
    }

    aiSupportCenter = {
        aiSupportCenterChatBot: {
            // view: this.isUserPermitted(['aiSupportCenter:*'])
            view: () => this.isSuperAdmin() || this.isUserPermitted(['aiSupportCenter:*'])()
        },
        documentation: {
            add: this.isUserPermitted(['aiSupportCenter.documentation:*']),
            view: this.isUserPermitted(['aiSupportCenter.documentation:*']),
            edit: this.isUserPermitted(['aiSupportCenter.documentation:*'])
        }
    }

    userLevelAccess = {
        edit: this.isUserPermitted(['moduleAccessProvider:*'])
    }

    aiInsightsAccess = {
        // view: this.isUserPermitted(['aiInsights:*'])
        view: ()=>{
                return this.isSuperAdmin() || this.isUserPermitted(['aiInsights:*'])();
            }
    }

    advanceRuleEngineAccess = {
        view: this.isPermitted(['ruleEngine:*', 'ruleEngine:view']),
        add: this.isPermitted(['ruleEngine:*', 'ruleEngine:add']),
        edit: this.isPermitted(['ruleEngine:*', 'ruleEngine:edit']),
        delete: this.isPermitted(['ruleEngine:*', 'ruleEngine:delete']),
    }

    // NEWDASHBOARD SCOPES...

    newDashboardAcces = () => {
        const allowedUsers= [
            'd7e6c9b5-f370-46a0-b7e5-26bdc2ae7246','345acb60-b2e7-4e83-aa80-c2c70797c76f','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7257','84c5b1e7-28a7-4fb1-a869-a3f60ee95318', 'a5319a0b-7025-4934-bcac-ba451807d5b2',
            '7ac346c0-33fd-4fa7-be08-b8465b58e7a9','93b19d88-6799-48aa-ac27-02b4e4fb93f9', 'ca9678e2-52d0-4cf3-a2c8-4dd5727d7d35','e9b21cf0-cc25-4474-a279-04616a0d78f1','f1b61727-2cbf-4a95-9760-be993796489b','2877faa5-6226-45dd-b575-9ef680d87844','fb972809-0dc9-481f-ac7f-167dc7eb0c99'
            ,'aefdba75-9d7d-4e9d-aab9-86f2944aad46','e59b69f1-0fad-4093-bfa4-cad5a531f3e4'
        ]
        return allowedUsers?.includes(localStorageInstance?.fetchUser()?.id ?? '') || access?.isOrgTypeExicom()
    }

    newDashboard = {
        view: () => this.isPermitted(['newDashbaord:*','newDashboard:view'])() || this.newDashboardAcces() ,
        rmsDisabledCard: () => this.isPermitted(['newDashbaord:*','newDashboard.rmsDisabledCard:view'])() || this.newDashboardAcces(),
        tiles: {
            overview: () => this.isPermitted(['newDashbaord:*','newDashboard.overview:view'])() || this.newDashboardAcces(),
            // deepAIInsights: () => this.isPermitted(['newDashbaord:*','newDashboard.deepAIInsights:view'])() ,
            deepAIInsights: this.aiInsightsAccess.view,
            alarmSummary: () => this.isPermitted(['newDashbaord:*','newDashboard.alarmSummary:view'])() || this.newDashboardAcces(),
            failedTransaction: () => this.isPermitted(['newDashbaord:*','newDashboard.failedTransaction:view'])() || this.newDashboardAcces(),
            overAllUptime : () => this.isPermitted(['newDashbaord:*','newDashboard.overAllUptime:view'])() || this.newDashboardAcces(),
            attentionRequiredChargers: () => this.isPermitted(['newDashbaord:*','newDashboard.attentionRequiredChargers:view'])() || this.newDashboardAcces(),
            attentionRequiredChargersCards: {
                criticalAlarms: () => this.isPermitted(['newDashbaord:*','newDashboard.attentionRequiredChargers.criticalAlarms:view'])() || this.newDashboardAcces(),
                uptime: () => this.isPermitted(['newDashbaord:*','newDashboard.attentionRequiredChargers.uptime:view'])() || this.newDashboardAcces(),
                oldFirmware: () => this.isPermitted(['newDashbaord:*','newDashboard.attentionRequiredChargers.oldFirmware:view'])() || this.newDashboardAcces(),
                offlineChargers: () => this.isPermitted(['newDashbaord:*','newDashboard.attentionRequiredChargers.offlineChargers:view'])() || this.newDashboardAcces(),
                utilization: () => this.isPermitted(['newDashbaord:*','newDashboard.attentionRequiredChargers.utilization:view'])() || this.newDashboardAcces(),
                failedTransactions: () => this.isPermitted(['newDashbaord:*','newDashboard.attentionRequiredChargers.failedTransactions:view'])() || this.newDashboardAcces(),
                session: () => this.isPermitted(['newDashbaord:*','newDashboard.attentionRequiredChargers.session:view'])() || this.newDashboardAcces()
            },
            chargingSessions : () => this.isPermitted(['newDashbaord:*','newDashboard.chargingSessions:view'])() || this.newDashboardAcces(),
            sessionTrend: () => this.isPermitted(['newDashbaord:*','newDashboard.sessionTrend:view'])() || this.newDashboardAcces(),
            chargingVsIdleTime: () => this.isPermitted(['newDashbaord:*','newDashboard.chargingVsIdleTime:view'])() || this.newDashboardAcces(),
            energyConsumption: () => this.isPermitted(['newDashbaord:*','newDashboard.energyConsumption:view'])() || this.newDashboardAcces(),
            efficiencyTrend: () => this.isPermitted(['newDashbaord:*','newDashboard.efficiencyTrend:view'])() || this.newDashboardAcces(),
            reactiveEnergyTrend: () => this.isPermitted(['newDashbaord:*','newDashboard.reactiveEnergyTrend:view'])() || this.newDashboardAcces()
        }
    }


    hasPlcConfigStopReasonsAccess = () => {
    return plcLogStopReasonPermittedUserIds?.includes(localStorageInstance?.fetchUser()?.id ?? '') && access?.isSuperAdmin()
    }
}

const access = new AccessControl();

export default access;